import { ButtonRow, PageSeo } from "../components/PageContent";
import { notFoundPage } from "../content/pagesContent";

export default function NotFoundPage() {
  const page = { ...notFoundPage, path: window.location.pathname };
  return (
    <>
      <PageSeo page={page} noindex />
      <section className="not-found">
        <div>
          <p className="eyebrow">404</p>
          <h1>{notFoundPage.headline}</h1>
          <p>{notFoundPage.body}</p>
          <ButtonRow ctas={notFoundPage.ctas} />
        </div>
      </section>
    </>
  );
}
